import { render } from "./BaseDate.vue?vue&type=template&id=fced77ec"
import script from "./BaseDate.js?vue&type=script&lang=js"
export * from "./BaseDate.js?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__